<template>
    <div :class="['library-sidebar-shell', isCollapsed ? 'is-collapsed' : '']">
        <ul class="menu bg-base-100 my-2 rounded-box h-screen-header shadow-xl library-sidebar-menu">
            <SidebarNav :collapsed="isCollapsed"/>
            <li class="library-sidebar-toggle">
                <button class="btn btn-ghost btn-sm w-full justify-start" @click="toggleCollapsed">
                    <svg xmlns="http://www.w3.org/2000/svg" :class="['h-5 w-5 transition-transform', isCollapsed ? 'rotate-180' : '']" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                    </svg>
                    <span v-if="!isCollapsed" class="ml-2">{{ $tt('收起') }}</span>
                </button>
            </li>
        </ul>
    </div>
</template>
<script>
    import SidebarNav from '@/components/library/SidebarNav'

    export default {
        components: {
            SidebarNav,
        },
        data() {
            return {
                isCollapsed: localStorage.getItem('library_sidebar_collapsed') !== '0',
                store: '',
            }
        },
        methods: {
            toggleCollapsed() {
                this.isCollapsed = !this.isCollapsed
                localStorage.setItem('library_sidebar_collapsed', this.isCollapsed ? '1' : '0')
                window.dispatchEvent(new CustomEvent('library-sidebar-collapsed-changed', {
                    detail: {
                        collapsed: this.isCollapsed
                    }
                }))
            },
            showSideBar() {
            }
        }
    }
</script>
<style>
.library-sidebar-shell {
    width: 14rem;
    flex: 0 0 14rem;
    transition: width 0.2s ease, flex-basis 0.2s ease;
}

.library-sidebar-shell.is-collapsed {
    width: 4.5rem;
    flex-basis: 4.5rem;
}

.library-sidebar-menu {
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.library-sidebar-menu > .library-sidebar-nav {
    flex: 1;
    overflow-y: auto;
}

.library-sidebar-toggle {
    margin-top: auto;
}

.library-sidebar-shell.is-collapsed .library-sidebar-toggle .btn {
    justify-content: center;
    padding-left: 0;
    padding-right: 0;
}
</style>
